import { render, staticRenderFns } from "./sw-account-locked-dialog.vue?vue&type=template&id=50f62619&scoped=true&"
import script from "./sw-account-locked-dialog.vue?vue&type=script&lang=ts&"
export * from "./sw-account-locked-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./sw-account-locked-dialog.vue?vue&type=style&index=0&id=50f62619&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f62619",
  null
  
)

export default component.exports